import MyDtrView from "../../features/dtr/MyDtrView";

const MyDtrPage = () => <MyDtrView />;

export default MyDtrPage;
